import { axiosInstance } from ".";

export const countryService = (state) => {
  return {
    async list() {
      const response = await axiosInstance.get("country");
      return response?.data || [];
    },
    async phoneCodes() {
      const response = await axiosInstance.get("country/phone-codes");
      return response?.data || [];
    },
  };
};
